<template>
  <span class="position-absolute top-100 start-100 translate-middle badge rounded-pill bg-success fw-bold">✅</span>
</template>

<script setup>
// was the `Accepted` object at the top of OrderBadge.js
defineOptions({ name: "OrderBadgeAccepted" })
</script>
